import React from "react";
import { Route, Routes } from "react-router-dom";

import { JOB_DETAIL_SEGMENT } from "@helpers/constants";

import JobDetail from "./views/JobDetail";
import JobsMonitor from "./views/JobsMonitor";
import NewJob from "./views/NewJob";

type Props = {
  onRouteNotFound?: () => void;
};

export default class Jobs extends React.Component<Props> {
  render() {
    const { onRouteNotFound } = this.props;
    return (
      <Routes>
        <Route path="/" element={<JobsMonitor />} />
        <Route path="/new" element={<NewJob />} />
        <Route
          path={`/${JOB_DETAIL_SEGMENT}/:jobIdentifier/*`}
          element={<JobDetail />}
        />
        <Route
          path="*"
          element={
            onRouteNotFound ? (
              (() => {
                onRouteNotFound();
                return null;
              })()
            ) : (
              <p>404 Not Found</p>
            )
          }
        />
      </Routes>
    );
  }
}
